import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LoadingOverlay } from "@mantine/core";
import AdminLayout from "@/components/AdminLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ImageList from "@/pages/image/ImageList";
import DatasetList from "@/pages/dataset/DatasetList";
import AuditList from "@/pages/audit/AuditList";
import AuditDetail from "@/pages/audit/AuditDetail";
import AuditDetect from "@/pages/audit/AuditDetect";
import ProjectList from "@/pages/project/ProjectList";
import ClassnameList from "@/pages/project/ClassnameList";
import ImageTypeList from "@/pages/project/ImageTypeList";
import ApiKeyList from "@/pages/project/ApiKeyList";
import UserList from "@/pages/user/UserList";

export default function App() {
  const { loading } = useAuth();

  if (loading) {
    return <LoadingOverlay visible />;
  }

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="image" element={<ImageList />} />
        <Route path="dataset" element={<DatasetList />} />
        <Route path="audit" element={<AuditList />} />
        <Route path="audit/:id" element={<AuditDetail />} />
        <Route path="audit/:id/:name" element={<AuditDetect />} />
        <Route path="settings/project" element={<ProjectList />} />
        <Route path="settings/classname" element={<ClassnameList />} />
        <Route path="settings/image-type" element={<ImageTypeList />} />
        <Route path="settings/api-key" element={<ApiKeyList />} />
        <Route path="settings/user" element={<UserList />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
